module.exports = __webpack_public_path__ + "img/ico-3-active.06fd1a32.svg";